import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

export const NotificationsSMSContainer = styled.div`
  width: 100%;
  height: 100%;
  color: #333940;
  background-color: ${RoutalPalette.neutral05};
`;

export const NotificationsSMSContainerHeader = styled.div`
  padding: 16px 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 38px;
  justify-content: space-between;
  background-color: ${RoutalPalette.neutral00};
  border-bottom: 1px solid ${RoutalPalette.neutral10};
`;

export const NotificationsSMSMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-y: auto;

  padding: 20px 0;
  height: calc(100% - 71px - 40px);
`;

export const NotificationsSMSMobileContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  border: 1px solid ${RoutalPalette.neutral10};
  border-radius: 10px;

  width: 328px;
  margin-bottom: 12px;
`;

export const NotificationsSMSMobileContainerContentBody = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  min-height: 500px;
  &:before,
  &:after {
    content: '';
    width: 1px;
    height: 40px;
  }
`;

export const NotificationsSMSMobileSpeechBubble = styled(Grid)`
  width: calc(100% - 60px);
  margin-left: 20px !important;
  margin-bottom: 40px !important;
  border-radius: 20px;
  border-bottom-left-radius: 0;
  background-color: ${RoutalPalette.neutral00};
  min-height: 160px;
  position: relative;
  &:before {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    left: -1px;
    bottom: -20px;
  }
  &:after {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid ${RoutalPalette.neutral00};
    border-right: 10px solid transparent;
    border-top: 10px solid ${RoutalPalette.neutral00};
    border-bottom: 10px solid transparent;
    left: 0px;
    bottom: -18px;
  }
`;
